export default __webpack_public_path__ + "static/media/watch-video_it.fb412217.png";